import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";
import axios from "axios";
import { fetchComboData, fetchComboDataWithWhere } from "../../services/api";
import { getHeaders } from "../../utility/getHeader";
import { getAuthToken } from "../../utility/getHeader";
import fetchData from "../../functions/fetchData";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "90%",
    maxWidth: "1200px",
    maxHeight: "85vh",
    borderRadius: "10px",
    zIndex: 10000,
    padding: "15px",
    overflow: "hidden"
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 9999,
  },
};

const NewItemPriceModal = ({ isOpen, customer, onClose, onItemAdded }) => {
  const [formdata, setFormData] = useState({
    unit: "",
    quantity_type: "",
    tax: "",
    subcat: "",
    isstockable: false,
    min_stock: "",
    item_code: "",
    barcode: "",
    brand: "",
    supplier_name: "",
    reorder_quantity: "",
    location: "",
    hsn_code: "",
    warranty_months: "",
    shelf_life_days: "",
    batch_tracking: false,
    serial_tracking: false,
  });

  const [getTax, setTax] = useState([]);
  const [getUnit, setUnits] = useState([]);
  const [getCategory, setCategory] = useState([]);
  const [SelectedCatID, setSelectedCatID] = useState([]);
  const [getSubCategory, setSubCategory] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [reload, setReload] = useState(false);
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});
  const [images, setImages] = useState([]);
  const [taxType, setTaxType] = useState(""); // For storing tax type from coresetting
  const [dynamicTaxOptions, setDynamicTaxOptions] = useState([]); // For dynamic tax options
  //   if (!customer) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  // Handle file changes and set preview
  const handleFileChange = (event) => {
    const selectedImages = Array.from(event.target.files).map((file) =>
      Object.assign(file, { preview: URL.createObjectURL(file) })
    );
    setImages((prevImages) => [...prevImages, ...selectedImages]);
  };

  const handleDeleteImage = (index) => {
    setImages(images.filter((_, i) => i !== index));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("[Add Item] formdata:", formdata);
    try {
      // Log request body and headers
      const requestBody = {
        iname: formdata.iname,
        unit: formdata.unit,
        weight: formdata.quantity_type,
        tax: formdata.tax,
        mrp: formdata.mrp,
        offerprice: formdata.offerprice,
        catid: formdata.category,
        subcatid: formdata.subcat,
        description: formdata.desc,
        isstockable: formdata.isstockable,
        min_stock: formdata.min_stock,
        item_code: formdata.item_code,
        barcode: formdata.barcode,
        brand: formdata.brand,
        supplier_name: formdata.supplier_name,
        reorder_quantity: formdata.reorder_quantity,
        location: formdata.location,
        hsn_code: formdata.hsn_code,
        warranty_months: formdata.warranty_months,
        shelf_life_days: formdata.shelf_life_days,
        batch_tracking: formdata.batch_tracking,
        serial_tracking: formdata.serial_tracking,
      };
      // console.log("[Add Item] Request body:", requestBody);
      // console.log("[Add Item] Request headers:", getHeaders());

      const post1 = await axios.post(
        "/insertdata/items",
        requestBody,
        getHeaders()
      );
     // console.log("[Add Item] post1 response:", post1);

      const formdata1 = e.target;
      const formData = new FormData();
      
      // Check if images exist before processing
      const hasImages = formdata1.images && formdata1.images.files && formdata1.images.files.length > 0;
      
      if (hasImages) {
        Array.from(formdata1.images.files).forEach((file, index) => {
          console.log(`📸 Adding image ${index + 1}:`, file.name, file.size, 'bytes');
          formData.append("images", file);
        });
      } else {
        console.log('ℹ️ No images selected - default image will be used');
      }
      
      formData.append("product_id", post1.data.id);
      formData.append("use_default", !hasImages ? "true" : "false"); // Flag to indicate default image should be used
      console.log('🆔 Product ID added:', post1.data.id);
      console.log('🖼️ Use default image:', !hasImages);

      // Only attempt image upload if images were selected OR to set default image
      try {
        // Check authentication before upload
        const token = getAuthToken();
        if (!token) {
          toast.error('Authentication required. Please log in again.');
          return;
        }

        // Get proper auth headers (but don't include Content-Type)
        const authHeaders = getHeaders();
        
        console.log('📸 Uploading images for product ID:', post1.data.id);
        console.log('📸 Number of images:', hasImages ? formdata1.images.files.length : 0);
        
        const post2 = await axios.post("/addnewproduct/item_images", formData, {
          headers: {
            // Only include Authorization - let axios set Content-Type with boundary
            'Authorization': authHeaders.headers.Authorization
          }
        });
        
        if (hasImages) {
          console.log('✅ Images uploaded successfully:', post2.data);
        } else {
          console.log('✅ Default image set successfully:', post2.data);
        }
      } catch (imgErr) {
        console.error('❌ Error processing images:', imgErr);
        
        // Enhanced error logging
        if (imgErr.response) {
          console.error('❌ Status:', imgErr.response.status);
          console.error('❌ Data:', imgErr.response.data);
          console.error('❌ Headers:', imgErr.response.headers);
          
          if (imgErr.response.status === 401) {
            toast.error('Authentication failed. Please log in again.');
          } else if (imgErr.response.status === 403) {
            toast.error('Insufficient permissions to process images.');
          } else if (imgErr.response.status === 500) {
            toast.error('Server error during image processing. Please try again.');
          } else {
            toast.error(`Image processing failed: ${imgErr.response.data?.message || 'Unknown error'}`);
          }
        } else if (imgErr.request) {
          console.error('❌ Network error:', imgErr.request);
          toast.error('Network error during image processing.');
        } else {
          console.error('❌ Error:', imgErr.message);
          toast.error(`Image processing error: ${imgErr.message}`);
        }
        
        // Don't fail the entire item creation if only image upload fails
        console.log('⚠️ Continuing despite image processing error - item was created successfully');
      }

      onItemAdded(); // Call this to trigger the reload function in NewItem
      toast.success("Item added successfully!");
      setImages([]);
      
      // Reset form and fetch new item code
      setFormData({
        unit: "",
        quantity_type: "",
        tax: "",
        subcat: "",
        isstockable: false,
        min_stock: "",
        item_code: "",
        barcode: "",
        brand: "",
        supplier_name: "",
        reorder_quantity: "",
        location: "",
        hsn_code: "",
        warranty_months: "",
        shelf_life_days: "",
        batch_tracking: false,
        serial_tracking: false,
      });
      
      // Fetch next item code for the next entry
      fetchNextItemCode();
      
      setTimeout(() => {
        onClose(); // Close modal
      }, 1000);
    } catch (err) {
      toast.error("Error in adding Item");
     // console.error("[Add Item] Error:", err);
      if (err.response) {
        // console.error("[Add Item] Error response data:", err.response.data);
        // console.error("[Add Item] Error response status:", err.response.status);
        // console.error("[Add Item] Error response headers:", err.response.headers);
      }
    }
    setErrors({});
  };

  // Fetch subcategories based on selected category
  const handleCategoryChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    const selectedCategoryId = e.target.value;
    setSelectedCategory(selectedCategoryId);

    if (selectedCategoryId) {
      try {
        const whereClause = { cat_id: selectedCategoryId };
        const data = await fetchComboDataWithWhere(
          "subcategory",
          "subcat",
          whereClause
        );
        setSubCategories(data);
      } catch (error) {
        console.error("Error fetching subcategories:", error);
      }
    } else {
      setSubCategories([]); // Clear subcategories if no category is selected
    }
  };

  const handleComboChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fetchNextItemCode = async () => {
    try {
      const itemCodeResponse = await axios.get("/items/next-item-code", getHeaders());
      if (itemCodeResponse.data.success) {
        const nextCode = itemCodeResponse.data.data.next_item_code;
        setFormData(prev => ({
          ...prev,
          item_code: nextCode
        }));
        toast.success(`Item code generated: ${nextCode}`);
      }
    } catch (error) {
      console.error("Error fetching next item code:", error);
      toast.error("Failed to generate item code");
    }
  };

  useEffect(() => {
    const fetchComboDataAsync = async () => {
      console.log("🔄 useEffect running - fetching combo data");
      
      try {
        // Fetch basic combo data
      //  console.log("📦 Fetching units...");
        const unitsData = await fetchComboData("units", "name");
      //  console.log("✅ Units fetched:", unitsData);
        setUnits(unitsData);
        
      //  console.log("📦 Fetching categories...");
        const categoriesData = await fetchComboData("categories", "name");
       // console.log("✅ Categories fetched:", categoriesData);
        setCategory(categoriesData);
        
        // Fetch next item code
        if (isOpen && !formdata.item_code) {
          try {
            console.log("📦 Fetching next item code...");
            const itemCodeResponse = await axios.get("/items/next-item-code", getHeaders());
            if (itemCodeResponse.data.success) {
              const nextCode = itemCodeResponse.data.data.next_item_code;
              console.log("✅ Next item code:", nextCode);
              setFormData(prev => ({
                ...prev,
                item_code: nextCode
              }));
            }
          } catch (error) {
            console.error("Error fetching next item code:", error);
            // Don't block form if this fails
          }
        }
        
        // Fetch tax type from coresetting table
      //  console.log("📦 Fetching tax type from coresetting...");
        const coreSettings = await fetchData("coresetting", null, "id", {});
        console.log("✅ Core settings fetched:", coreSettings);
        
        let currentTaxType = "gst"; // default
        
        if (coreSettings && coreSettings.length > 0) {
          // Direct column access - tax_type is a column in coresetting table
          const taxTypeValue = coreSettings[0].tax_type;
          if (taxTypeValue) {
            currentTaxType = taxTypeValue.toLowerCase();
            console.log("🎯 Tax type from database:", currentTaxType);
          }
        }
        
        console.log("📋 Final tax type being used:", currentTaxType);
        
        setTaxType(currentTaxType);
        
        // Create dynamic tax options based on tax type
        let taxOptions = []
        if (currentTaxType === "vat") {
          taxOptions = [
            { id: 1, taxname: "VAT 0%", taxvalue: "0" },
            { id: 2, taxname: "VAT 7%", taxvalue: "7" }
          ];
          console.log("✅ VAT options created:", taxOptions);
        } else {
          // For GST or any other tax type, fetch from taxes table
       //   console.log("📦 Fetching tax options from taxes table...");
          taxOptions = await fetchComboData("taxes", "taxname");
        //  console.log("✅ Tax options fetched:", taxOptions);
        }
        
        setDynamicTaxOptions(taxOptions);
        setTax(taxOptions); // Keep backward compatibility

        // console.log("🎯 Tax type loaded:", currentTaxType);
        // console.log("🎯 Tax options loaded:", taxOptions);
        // console.log("✅ All combo data fetched successfully");

      } catch (error) {
        console.error("❌ Error fetching combo data:", error);
        // Fallback to default tax options
        try {
          const fallbackTaxOptions = await fetchComboData("taxes", "taxname");
          setTax(fallbackTaxOptions);
        } catch (fallbackError) {
          console.error("❌ Error fetching fallback tax options:", fallbackError);
        }
      }
    };

    // Only run if modal is open
    if (isOpen) {
      fetchComboDataAsync();
    }
  }, [isOpen]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      contentLabel="New Item Entry"
      style={customStyles}
      ariaHideApp={false}

    >
      <ToastContainer />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          
        }}
      >
        <h4>Add New Item</h4>
        <button
          onClick={onClose}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
          }}
        >
          <FaTimes size={20} color="red" /> {/* Close icon */}
        </button>
      </div>
      <hr
        style={{ width: "99%", border: "1px solid #ccc", margin: "8px 0" }}
      />
      <div style={{ 
        maxHeight: "calc(85vh - 120px)", 
        overflowY: "auto",
        padding: "10px 15px"
      }}>
        <form onSubmit={handleSubmit}>
          <div className="row" style={{ margin: "0", paddingRight: "10px" }}>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Item Name</label>
                <input
                  id="iname"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.iname}
                  type="text"
                  name="iname"
                  className="form-control"
                  style={{
                    height: '35px',
                    fontSize: '13px',
                    borderRadius: '6px',
                    border: '1px solid #17a2b8',
                    backgroundColor: '#f8f9fc',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f8f9fc'}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>
                  Item Code
                </label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <input
                    id="item_code"
                    onChange={(e) => handleInputChange(e)}
                    value={formdata.item_code}
                    type="text"
                    name="item_code"
                    className="form-control"
                    placeholder="Auto-generated"
                    style={{
                      borderRadius: "6px",
                      border: "1px solid #17a2b8",
                      height: "35px",
                      flex: 1,
                      fontSize: '13px',
                      backgroundColor: '#f8f9fc',
                      transition: 'all 0.2s ease'
                    }}
                    onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                    onBlur={(e) => e.target.style.backgroundColor = '#f8f9fc'}
                  />
                  <button
                    type="button"
                    onClick={fetchNextItemCode}
                    className="btn btn-info btn-sm"
                    style={{ height: "35px", width: "35px", padding: "0", fontSize: '12px' }}
                    title="Generate next item code"
                  >
                    <i className="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Barcode</label>
                <input
                  id="barcode"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.barcode}
                  type="text"
                  name="barcode"
                  className="form-control"
                  style={{
                    height: '35px',
                    fontSize: '13px',
                    borderRadius: '6px',
                    border: '1px solid #17a2b8',
                    backgroundColor: '#f8f9fc',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f8f9fc'}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>
                  Unit
                </label>
                <select
                  id="unit"
                  name="unit"
                  className="form-select custom-select"
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #17a2b8",
                    height: "35px",
                    width: "100%",
                    fontSize: '13px',
                    backgroundColor: '#f0f8ff',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f0f8ff'}
                  onChange={handleComboChange}
                  value={formdata.unit}
                >
                  <option value="">Select Unit</option>
                  {getUnit.map((units) => (
                    <option key={units.id} value={units.name}>
                      {units.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>
                  Item Type
                </label>
                <select
                  id="quantity_type"
                  name="quantity_type"
                  className="form-select custom-select"
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #17a2b8",
                    height: "35px",
                    width: "100%",
                    fontSize: '13px',
                    backgroundColor: '#f0f8ff',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f0f8ff'}
                  onChange={handleComboChange}
                  value={formdata.quantity_type}
                >
                  <option value="">Select type</option>
                  <option value="unit">Per Piece</option>
                  <option value="weight">Per KG</option>
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>
                  Tax {taxType ? `(${taxType.toUpperCase()})` : ''}
                </label>
                <select
                  id="tax"
                  name="tax"
                  className="form-select custom-select"
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #17a2b8",
                    height: "35px",
                    width: "100%",
                    fontSize: '13px',
                    backgroundColor: '#f0f8ff',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f0f8ff'}
                  onChange={handleComboChange}
                  value={formdata.tax}
                >
                  <option value="">Select {taxType ? taxType.toUpperCase() : 'Tax'}</option>
                  {getTax.map((taxes) => (
                    <option key={taxes.id} value={taxes.taxvalue}>
                      {taxes.taxname}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>MRP</label>
                <input
                  id="mrp"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.mrp}
                  type="number"
                  name="mrp"
                  className="form-control"
                  style={{
                    height: '35px',
                    fontSize: '13px',
                    borderRadius: '6px',
                    border: '1px solid #17a2b8',
                    backgroundColor: '#fff8f0',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#fff8f0'}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Selling Price</label>
                <input
                  id="offerprice"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.offerprice}
                  type="number"
                  name="offerprice"
                  className="form-control"
                  style={{
                    height: '35px',
                    fontSize: '13px',
                    borderRadius: '6px',
                    border: '1px solid #17a2b8',
                    backgroundColor: '#fff8f0',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#fff8f0'}
                />
              </div>
            </div>
            
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>
                  Category
                </label>
                <select
                  id="category"
                  name="category"
                  className="form-select custom-select"
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #17a2b8",
                    height: "35px",
                    width: "100%",
                    fontSize: '13px',
                    backgroundColor: '#f0f8ff',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f0f8ff'}
                  onChange={handleCategoryChange}
                  value={formdata.category}
                >
                  <option value="">Select Category</option>
                  {getCategory.map((options) => (
                    <option key={options.id} value={options.id}>
                      {options.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>
                  SubCategory
                </label>
                <select
                  id="subcat"
                  name="subcat"
                  className="form-select custom-select"
                  style={{
                    borderRadius: "6px",
                    border: "1px solid #17a2b8",
                    height: "35px",
                    width: "100%",
                    fontSize: '13px',
                    backgroundColor: '#f0f8ff',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f0f8ff'}
                  value={formdata.subcat}
                  onChange={handleComboChange}
                >
                  <option value="">Select SubCategory</option>
                  {subCategories.map((options) => (
                    <option key={options.id} value={options.id}>
                      {options.subcat}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Description</label>
                <input
                  id="iname"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.iname}
                  type="text"
                  name="iname"
                  className="form-control"
                  style={{
                    height: '35px',
                    fontSize: '13px',
                    borderRadius: '6px',
                    border: '1px solid #17a2b8',
                    backgroundColor: '#f8f9fc',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f8f9fc'}
                />
              </div>
            </div>
            
            {/* Retail Inventory Fields - Row 2 */}
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Brand</label>
                <input
                  id="brand"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.brand}
                  type="text"
                  name="brand"
                  className="form-control"
                  style={{ height: '35px', fontSize: '13px', borderRadius: '4px', border: '1px solid #17a2b8' }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Supplier</label>
                <input
                  id="supplier_name"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.supplier_name}
                  type="text"
                  name="supplier_name"
                  className="form-control"
                  style={{ height: '35px', fontSize: '13px', borderRadius: '4px', border: '1px solid #17a2b8' }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>HSN/SAC</label>
                <input
                  id="hsn_code"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.hsn_code}
                  type="text"
                  name="hsn_code"
                  className="form-control"
                  style={{ height: '35px', fontSize: '13px', borderRadius: '4px', border: '1px solid #17a2b8' }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Location</label>
                <input
                  id="location"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.location}
                  type="text"
                  name="location"
                  className="form-control"
                  style={{ height: '35px', fontSize: '13px', borderRadius: '4px', border: '1px solid #17a2b8' }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Min Stock</label>
                <input
                  id="min_stock"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.min_stock}
                  type="number"
                  name="min_stock"
                  className="form-control"
                  style={{ height: '35px', fontSize: '13px', borderRadius: '4px', border: '1px solid #17a2b8' }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Reorder Qty</label>
                <input
                  id="reorder_quantity"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.reorder_quantity}
                  type="number"
                  name="reorder_quantity"
                  className="form-control"
                  style={{ height: '35px', fontSize: '13px', borderRadius: '4px', border: '1px solid #17a2b8' }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Warranty (M)</label>
                <input
                  id="warranty_months"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.warranty_months}
                  type="number"
                  name="warranty_months"
                  className="form-control"
                  style={{ height: '35px', fontSize: '13px', borderRadius: '4px', border: '1px solid #17a2b8' }}
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className="form-group" style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>Shelf Life (D)</label>
                <input
                  id="shelf_life_days"
                  onChange={(e) => handleInputChange(e)}
                  value={formdata.shelf_life_days}
                  type="number"
                  name="shelf_life_days"
                  className="form-control"
                  style={{ height: '35px', fontSize: '13px', borderRadius: '4px', border: '1px solid #17a2b8' }}
                />
              </div>
            </div>

            {/* Checkboxes Row */}
            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className='form-group' style={{ marginBottom: '15px' }}>
                <label className='control-label' style={{ fontSize: '13px', marginBottom: '8px', display: 'block', fontWeight: '500' }}>Inventory Options</label>
                <div style={{ 
                  display: 'flex', 
                  flexWrap: 'wrap',
                  gap: '6px',
                  padding: '8px',
                  backgroundColor: '#f8f9fc',
                  borderRadius: '6px',
                  border: '1px solid #e3e6f0',
                  alignItems: 'center'
                }}>
                  <label style={{ 
                    fontSize: '11px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    cursor: 'pointer',
                    padding: '3px 6px',
                    borderRadius: '3px',
                    transition: 'background-color 0.2s ease',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e7f3ff'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
                    <input
                      type="checkbox"
                      id="isstockable"
                      name="isstockable"
                      checked={formdata.isstockable}
                      onChange={(e) => setFormData((prevData) => ({ ...prevData, isstockable: e.target.checked }))}
                      style={{ 
                        marginRight: "4px", 
                        transform: "scale(1.0)",
                        accentColor: '#17a2b8'
                      }}
                    />
                    <span style={{ fontWeight: '500' }}>Stockable</span>
                  </label>
                  <label style={{ 
                    fontSize: '11px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    cursor: 'pointer',
                    padding: '3px 6px',
                    borderRadius: '3px',
                    transition: 'background-color 0.2s ease',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e7f3ff'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
                    <input
                      type="checkbox"
                      id="batch_tracking"
                      name="batch_tracking"
                      checked={formdata.batch_tracking}
                      onChange={(e) => setFormData((prevData) => ({ ...prevData, batch_tracking: e.target.checked }))}
                      style={{ 
                        marginRight: "4px", 
                        transform: "scale(1.0)",
                        accentColor: '#28a745'
                      }}
                    />
                    <span style={{ fontWeight: '500' }}>Batch Track</span>
                  </label>
                  <label style={{ 
                    fontSize: '11px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    cursor: 'pointer',
                    padding: '3px 6px',
                    borderRadius: '3px',
                    transition: 'background-color 0.2s ease',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#e7f3ff'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}>
                    <input
                      type="checkbox"
                      id="serial_tracking"
                      name="serial_tracking"
                      checked={formdata.serial_tracking}
                      onChange={(e) => setFormData((prevData) => ({ ...prevData, serial_tracking: e.target.checked }))}
                      style={{ 
                        marginRight: "4px", 
                        transform: "scale(1.0)",
                        accentColor: '#ffc107'
                      }}
                    />
                    <span style={{ fontWeight: '500' }}>Serial Track</span>
                  </label>
                </div>
              </div>
            </div>
            
            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className='form-group' style={{ marginBottom: '15px' }}>
                <label className='control-label' style={{ fontSize: '13px', marginBottom: '4px', display: 'block', fontWeight: '500' }}>Product Images</label>
                <input
                  type="file"
                  name="images"
                  multiple
                  accept="image/*"
                  onChange={handleFileChange}
                  style={{ 
                    fontSize: '12px', 
                    height: '35px',
                    borderRadius: '6px',
                    border: '1px solid #17a2b8',
                    backgroundColor: '#f5f8fa',
                    padding: '4px 8px',
                    width: '100%',
                    transition: 'all 0.2s ease'
                  }}
                  onFocus={(e) => e.target.style.backgroundColor = '#ffffff'}
                  onBlur={(e) => e.target.style.backgroundColor = '#f5f8fa'}
                />
                <small className="form-text text-muted" style={{ fontSize: '11px', color: '#6c757d' }}>
                  Optional - default used if none selected
                </small>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-12 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
              <div className='form-group' style={{ marginBottom: '15px' }}>
                <label className="control-label" style={{ fontSize: '13px', marginBottom: '4px', display: 'block' }}>&nbsp;</label>
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{ 
                    height: '40px', 
                    fontSize: '14px', 
                    width: '100%',
                    borderRadius: '6px',
                    fontWeight: '600',
                    backgroundColor: '#007bff',
                    border: 'none',
                    transition: 'all 0.2s ease',
                    boxShadow: '0 2px 4px rgba(0,123,255,0.2)'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#0056b3';
                    e.target.style.transform = 'translateY(-1px)';
                    e.target.style.boxShadow = '0 4px 8px rgba(0,123,255,0.3)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#007bff';
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 2px 4px rgba(0,123,255,0.2)';
                  }}
                >
                  <i className="fa fa-plus" style={{ marginRight: '6px' }}></i>
                  Add Item
                </button>
              </div>
            </div>
            
            {/* Image Preview Section */}
            {images.length > 0 && (
              <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{ paddingRight: '8px', paddingLeft: '8px' }}>
                <div className="image-preview" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '15px' }}>
                  {images.map((image, index) => (
                    <div key={index} className="preview-item" style={{ position: 'relative', display: 'inline-block' }}>
                      <img
                        src={image.preview}
                        alt="preview"
                        style={{ width: "80px", height: "80px", objectFit: 'cover', borderRadius: '4px', border: '1px solid #ddd' }}
                      />
                      <button
                        type="button"
                        onClick={() => handleDeleteImage(index)}
                        style={{
                          position: 'absolute',
                          top: '-5px',
                          right: '-5px',
                          background: 'red',
                          color: 'white',
                          border: 'none',
                          borderRadius: '50%',
                          width: '20px',
                          height: '20px',
                          fontSize: '12px',
                          cursor: 'pointer'
                        }}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default NewItemPriceModal;
